import get from 'lodash.get';
import { createSelector } from 'src/universal/redux/utils';
// selectors
import {
  getPageFirstCardData,
  getPageData,
  getPageAllowedLists
} from 'src/universal/redux/page';
import {
  getPznOfferByShortName,
  hasPznDataArrived
} from 'src/universal/redux/pznData';

import {
  getPdpCardShortName,
  getOfferBadgeText
} from 'page_modules/business-pdp/redux';

// utils
import { buildBadge, buildIcon, buildOfferContent } from './utils';

export const isPDPDualOffer = createSelector(
  [getPdpCardShortName, getPageAllowedLists],
  (pdpShortName, allowedlists) => {
    const isCardInList =
      (get(allowedlists, 'pdpDualOfferModule') || []).indexOf(pdpShortName) > -1;
    return isCardInList;
  }
);

export const getDualOfferContent = cardName =>
  createSelector(
    [
      hasPznDataArrived,
      getPznOfferByShortName(cardName),
      getPageFirstCardData,
      isPDPDualOffer,
      getOfferBadgeText
    ],
    (pznDataArrived, offer, cardData, isDualOffer, offerBadgeText) => {
      if (!pznDataArrived || !offer.shortName) {
        return { shouldRenderDualOffer: false };
      }

      const singleOffer = {
        header: offer.header,
        description: offer.description,
        flag: offerBadgeText
      };
      const dualOfferContent = {
        content: buildOfferContent(offer, cardData),
        separatorIcon: buildIcon(),
        badgeArray: buildBadge(offerBadgeText)
      };
      return {
        shouldRender: isDualOffer,
        dualOfferContent: dualOfferContent,
        singleOffer: singleOffer
      };
    }
  );

export const getDualOfferDTM = createSelector(
  [getPageData, isPDPDualOffer, getPdpCardShortName],
  (pageData, isBluePDP, cardName) => {
    const dtmEvents = get(pageData, 'dtmEvents') || [];
    const dualOfferDtm = !isBluePDP
      ? dtmEvents.find(e => e.key === 'dualoffer') || {}
      : dtmEvents.find(e => e.key === `DualOffer_${cardName}`) || {};

    return dualOfferDtm;
  }
);
